import React from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import ActionsFactory from 'src/actions/ActionsFactory';
import AVText from 'src/components/elements/AVText';
import BackSubheader from 'src/components/elements/BackSubheader';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import AccountStore from 'src/stores/AccountStore';

const DeleteAccountScreen = () => {
  const deletePressed = async () => {
    const {deleteAccount, logout} = ActionsFactory.getAccountActions();
    await deleteAccount(AccountStore.getAccountId(), AccountStore.getEmail());
    logout();
  };
  return (
    <BackSubheader title={Localized.Labels.delete_account}>
      <ScrollView style={styles.content}>
        <AVText style={styles.disclaimerTextBold}>
          {Localized.Labels.voluntary_deletion_1}
        </AVText>
        <AVText style={styles.disclaimerText}>
          {Localized.Labels.voluntary_deletion_2}
        </AVText>
      </ScrollView>
      <RoundedButton
        buttonType={ButtonType.action}
        color={Styles.dangerColor}
        onPress={deletePressed}
        accessibilityLabel="Continue"
        text={Localized.Buttons.delete}
      />
    </BackSubheader>
  );
};

const styles = StyleSheet.create({
  content: {
    padding: Styles.Spacing.m3,
  },
  disclaimerText: {
    marginBottom: Styles.Spacing.m1,
  },
  disclaimerTextBold: {
    marginBottom: Styles.Spacing.m1,
    fontWeight: 'bold',
  },
});

export default DeleteAccountScreen;
